import { render, staticRenderFns } from "./popularPosts.vue?vue&type=template&id=274ff905&scoped=true&"
import script from "./popularPosts.vue?vue&type=script&lang=ts&"
export * from "./popularPosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ff905",
  null
  
)

export default component.exports